import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { AiChangeType } from '../../../../../../../ai';
import { EssayAddQuestionStrategy } from './essay-add.strategy';
import { EssayDeleteQuestionStrategy } from './essay-delete.strategy';
import { EssayUpdateQuestionStrategy } from './essay-update.strategy';
export var EssayAiChangeStrategyFactory = /*#__PURE__*/function () {
  function EssayAiChangeStrategyFactory() {
    _classCallCheck(this, EssayAiChangeStrategyFactory);
  }

  _createClass(EssayAiChangeStrategyFactory, null, [{
    key: "create",
    value: function create(context) {
      switch (context.changeType) {
        case AiChangeType.Add:
          return new EssayAddQuestionStrategy(context);

        case AiChangeType.Update:
          return new EssayUpdateQuestionStrategy(context);

        case AiChangeType.Delete:
          return new EssayDeleteQuestionStrategy(context);

        default:
          throw new Error('Unsupported change type for essay');
      }
    }
  }]);

  return EssayAiChangeStrategyFactory;
}();